<template style="height: 100%">
    <div class="ra">
        <!--头部-->
        <div class="flex0">
            <el-select style="width: 145px"  class="marr4" v-model="isAccountTime" size="mini" filterable :placeholder="$t('form_please_select')">
                <el-option
                        v-for="item in timeType"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-date-picker
                    class="marr4"
                    size="mini"
                    v-model="begin_time"
                    formt="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 15%"
                    :placeholder="$t('promanagement_startDate')"　>
            </el-date-picker>
            <el-date-picker
                    class="marr4"
                    size="mini"
                    v-model="end_time"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 15%"
                    :placeholder="$t('promanagement_endDate')"　>
            </el-date-picker>
            <el-input class="marr4" style="width: 15%" v-model="vcName" :placeholder="$t('promanagement_search_for_product_name_or_batch_number')"　 clearable size="mini"></el-input>
            <el-button  icon="el-icon-search" circle  @click="searchData" size="mini"></el-button>
            <el-button type="primary" @click="addData" :disabled="disabled" :class="baseerp+'btn'" size="mini" >{{$t('button_add')}}</el-button>
            <el-button type="primary" @click="editData"  :class="baseerp+'btn'" size="mini">{{$t('button_edit')}}</el-button>
        </div>
        <!--表单部分-->
        <div  class="tableHeight">
            <el-table
                    border
                    ref="table"
                    class="mrt10"
                    size="mini"
                    :data="tableData"
                    :height="tableHeight"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    @row-click="rowClick"
                    :highlight-current-row="highlightCurrentRow">
                <el-table-column
                        prop="i_id"
                        :label="$t('form_request_no')"
                        width="90">
                </el-table-column>
                <el-table-column
                        prop="vc_hqgsname"
                        :label="$t('form_goods_rights_company')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="vc_gsname"
                        :label="$t('form_corporate_name')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="vc_ckname"
                        :label="$t('form_warehouse')"
                        width="85"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="vc_pzname"
                        :label="$t('form_product_name')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="vc_no"
                        :label="$t('form_warehouse_number')"
                        min-width="110"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="f_num"
                        :label="$t('form_quantity')"
                        width="80"
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_innum"
                        :label="$t('promanagement_quantity_already_in_stock')"
                        width="85"
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="vc_unit"
                        :label="$t('form_unit')"
                        width="70">
                </el-table-column>
                <el-table-column
                        prop="vc_squname"
                        :label="$t('form_applicant')"
                        width="80"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="dt_createtime"
                        :label="$t('form_application_date')"
                        min-width="180"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="dt_accounttime"
                        :label="$t('promanagement_accountingTime')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <!--<el-table-column
                        prop="state"
                        :label="状态"
                        width="80">
                </el-table-column>-->
            </el-table>
            <el-pagination
                    class="fr page"
                    background
                    layout="prev, pager, next"
                    @current-change="pageCurrentChange"
                    :current-page.sync="currentPage"
                    :total="tableTotal"
                    :page-size="pageSize">
            </el-pagination>
        </div>
        <!--dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                    width="1000px"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <stock-details :application="application" @close="cancelDialog" @getCjReturnList="getCjReturnList"></stock-details>
            </el-dialog>
        </div>

        <!--分页-->
        <!--<div>

        </div>-->
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import * as API from  "./api";
    import axios from "axios";
    import StockDetails from "./StockDetails";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "StockreturnList",
        components:{StockDetails},
        props:{
            formvalue:{
                type:Object,
                required:true,

            }
        },
        mounted(){
            this.baseerp=baseerp;
            ///调用列表接口
            //this.getlist();
           // console.log(this.formvalue,"this.formvalue");
           //  this.$nextTick(function () {
           //      this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 280;
           //
           //      // 监听窗口大小变化
           //      let self = this;
           //      window.onresize = function() {
           //          self.tableHeight = window.innerHeight - self.$refs.table.$el.clientTop - 280
           //      }
           //      // console.log(window.innerHeight,"H")
           //  })
            this.$nextTick(function () {
                window.addEventListener('resize',this.heightAuto);
                this.heightAuto();
            });
            //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
            //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度　

        },

        data(){
            return{
                timeType:[  {i_id:0,vc_name:this.$t('promanagement_search_by_entry_time')},
                            {i_id:1,vc_name:this.$t('promanagement_search_by_accounting_time')}],
                isAccountTime:0,
                i_id:"",
                i_type:"",
                apptitle:"",
                bfapp:[],
                dialogVisible:false,
                title:"",
                begin_time:"",
                end_time:"",
                tableData:[],
                pageSize:16,
                currentPage:1,
                tableTotal:0,
                vcName:"",
                application:{},
                highlightCurrentRow:false,
                disabled:false,
                baseerp:"",
                mid:0,
                tableHeight:0,
            }
        },
        watch:{
            formvalue:{
                handler(){
                    if (this.formvalue){
                        if(this.i_id!=this.formvalue.i_id) {
                            if ((this.formvalue.i_id ?? '' !== '') && (this.formvalue.i_id != 0)) {
                                this.mid=this.formvalue.i_mid;
                                this.i_type = this.formvalue.i_type;
                                this.bfapp = this.formvalue.value;
                                this.i_id = this.formvalue.i_id;
                                this.i_type = this.formvalue.i_type;
                                //this.apptitle = this.formvalue.title;
                                this.getCjReturnList();
                                // console.log(this.bfapp,this.i_id,this.i_type,this.apptitle,"this.bfapp");
                                /*if (this.formvalue.value.dt_createtime>=this.formvalue.value.dt_starttime&&this.formvalue.value.dt_createtime<=this.formvalue.value.dt_endtime){
                                    this.disabled=false;
                                   // console.log(this.formvalue.value.dt_createtime,this.formvalue.value.dt_starttime,this.formvalue.value.dt_endtime,"check")
                                }else{
                                    this.disabled=true;
                                };250804*/
                                //console.log(this.formvalue.value.jz,"this.jz");
                                if(this.formvalue.value.jz==true){
                                    this.disabled=true;
                                }else{
                                    this.disabled=false;
                                }
                            }
                        }
                    }
                },
                immediate:true,
                deep:true
            },

        },

        methods:{
            ...mapActions(["getCurrentMenuId"]),
            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 300;
            },
            //拿到当前行数据
            rowClick(row){
                this.highlightCurrentRow=true;
                //console.log(row,"row");
                this.application.i_pid=row.i_pid;
               // console.log(this.application,"this.application",this.application.i_pid)
            },

            //关闭dialog
            cancelDialog(val){
                //console.log(val,"val,,,,,,");
                this.application.i_pid="";
                this.dialogVisible=false;
              //  console.log(this.application.i_pid,"cancelDialog");
                this.highlightCurrentRow=false;
                this.getCjReturnList(val);
            },

            //点击编辑
            editData(){
                this.title=this.$t('promanagement_edit_application_form');
                if (this.application.i_pid==""||this.application.i_pid==undefined){
                  //  console.log(this.application,"this.application",this.application.i_pid);
                    this.dialogVisible=false;
                    this.$message.error(this.$t('promanagement_please_select_the_line_content_to_be_edited'))
                }else{
                    this.application={
                        i_pid:this.application.i_pid,
                        page_size:this.currentPage,
                        value:this.bfapp,
                        i_id:this.i_id,
                        i_type:this.i_type,
                        title:this.title,
                        i_mid:this.mid,
                    };
                  //  console.log(this.application,"editData");
                    this.dialogVisible=true;
                }

            },

            //点击添加
            addData(){
                if(this.formvalue.title==null||this.formvalue==null){
                    this.dialogVisible=false;
                    this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                }else{
                    this.title=this.$t('promanagement_add_application_form');
                    this.highlightCurrentRow=false;
                    this.application={
                        i_pid:0,
                        page_size:1,
                        value:this.bfapp,
                        i_id:this.i_id,
                        i_type:this.i_type,
                        title:this.title,
                        i_mid:this.mid,
                        jz:this.formvalue.value.jz,
                    };
                   // console.log(this.application,"addData");
                    this.dialogVisible=true;
                }

            },


            //点击查询
            searchData(){
               // console.log(this.vcName,this.begin_time,this.end_time,"searchData");
                if(this.formvalue.title==null||this.formvalue==null){
                    this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                    return
                }
                this.getCjReturnList();
            },

            //列表接口
            // getlist(){
            //     const that=this;
            //     axios.get("./requestlist.json").then(function (res) {
            //         console.log(res.data,"getlist");
            //         that.tableData=res.data;
            //     })
            // },
            async getCjReturnList(pageSize){

                if(pageSize!=undefined) {
                   // console.log(pageSize,"pageSize");
                    this.currentPage=pageSize;
                }
                let param = {
                    i_rwid:this.formvalue.i_id,
                    i_mid: this.mid,
                    page_size:this.currentPage,
                    page_count:16,
                    begin_time:this.begin_time?this.begin_time:'',
                    end_time:this.end_time?this.end_time:'',
                    vc_name:this.vcName,
                    isAccountTime:this.isAccountTime,
                };
                let res = await API.getCjReturnList(param);
                if (res.code == 1) {
                    this.tableData=res.data;
                    this.tableTotal=res.count;
                    //console.log(this.tableData,this.tableTotal,"this.tableData");
                    //this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                ///调用列表接口
                this.getCjReturnList();
            },
        },

        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }

</script>

<style lang="scss" scoped>
    .mrt10{
        margin-top: 6px;
    }
    .marr4{
        margin-right: 6px;
    }
    .ra{
        height: 100%;
    }
    .flex{
        justify-content: left;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .cl{
        clear: both;
    }
    .mrt10{
        margin-top: 6px;
    }
    .mrt20{
        margin-top: 10px;
    }
    .mrl20{
        margin-left: 10px;
    }
    .mrb40{
        margin-bottom: 60px;
    }
    /*.page{
        padding: 25px 15px;
    }*/
    .middle{
        line-height: 30px;
    }
    /*.tableHeight{
        min-height: 460px;
        height: 100%;
    }*/
    /deep/{

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }
        .el-tabs--border-card > .el-tabs__content{
            height: calc(100% - 60px);
            overflow-y: auto;

        }
    }



</style>